<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.75 0H2.25C1.00951 0 0 1.00951 0 2.25V15.75C0 16.9905 1.00951 18 2.25 18H15.75C16.9905 18 18 16.9905 18 15.75V2.25C18 1.00951 16.9905 0 15.75 0ZM16.5 15.75C16.5 16.164 16.164 16.5 15.75 16.5H6.75V12.375C6.75 11.754 6.246 11.25 5.625 11.25H1.50005V2.25C1.50005 1.83595 1.83595 1.50005 2.25 1.50005H15.75C16.164 1.50005 16.5 1.83595 16.5 2.25V15.75Z" fill="currentColor" />
    <path d="M14.2501 3H9.75014C9.44719 3 9.17267 3.18224 9.05717 3.4628C8.94099 3.74336 9.0054 4.06581 9.21991 4.28032L10.9397 6.00009L7.72 9.21977C7.42667 9.51311 7.42667 9.98703 7.72 10.2802C7.86612 10.4265 8.05824 10.5001 8.25023 10.5001C8.44221 10.5001 8.6342 10.4265 8.78046 10.2802L12.0001 7.06055L13.7199 8.78032C13.8631 8.92355 14.0551 9.00005 14.2501 9.00005C14.347 9.00005 14.4445 8.98206 14.5374 8.94305C14.818 8.82756 15.0002 8.55304 15.0002 8.25009V3.75009C15.0002 3.33536 14.6649 3 14.2501 3Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'SidebarOpen',
};
</script>
